<script lang="ts">
import { defineComponent } from 'vue';
import { login, setPassword } from '@/api/admin-be';
import { mapActions, mapWritableState } from 'pinia';
import { useAppStore } from '@/stores/app';
// import { useUsersStore } from '@/stores/users';

export default defineComponent({
  name: 'login',
  computed: {
    ...mapWritableState(useAppStore, ['token', 'userName']),
  },
  data() {
    return {
      loading: false,
      name: '' as string,
      secret: '' as string,
      newPassword1: '' as string,
      newPassword2: '' as string,
      error: null as null | string,
      setup: false,
      mouseHold: false,
    };
  },
  methods: {
    ...mapActions(useAppStore, ['setToken', 'setUserName']),
    onKeyUp(event: KeyboardEvent) {
      if (event.key === 'Enter') {
        this.formLogin();
      }
    },
    onPasswordKeyUp(event: KeyboardEvent) {
      if (event.key === 'Enter') {
        this.formSendPassword();
      }
    },
    onNameKeyUp(event: KeyboardEvent) {
      if (event.key === 'Enter') {
        this.formLogin();
      }
    },
    formLogin() {
      this.error = null;
      this.loading = true;
      setTimeout(() => {
        login(this.name as string, this.secret as string)
          .then(({ token }) => {
            if (!token) {
              this.setup = true;
            } else {
              this.setUserName(this.name);
              this.setToken(token);
            }
          })
          .catch((err) => {
            this.error = err.response.data?.message;
          })
          .finally(() => {
            this.loading = false;
          });
      }, 300);
    },
    formSendPassword() {
      this.error = null;
      this.loading = true;

      setTimeout(() => {
        setPassword(this.name, this.secret, this.newPassword1, this.newPassword2)
          .then(() => {
            this.setup = false;
          })
          .catch((err) => {
            this.error = err.response.data?.message;
          })
          .finally(() => {
            this.loading = false;
          });
      }, 300);
    },
    validPassword() {
      return (
        this.newPassword1.length >= 8 &&
        /[A-Z]/g.test(this.newPassword1) &&
        /[a-z]/g.test(this.newPassword1) &&
        /\d/g.test(this.newPassword1)
      );
    },
  },
  mounted() {
    this.name = this.userName || '';
  },
});
</script>

<template>
  <content class="absolute left-0 top-0 right-0 bottom-0 flex flex-row min-h-screen justify-center items-center">
    <div class="absolute left-0 top-0 right-0 bottom-[60vh] custom-background" />
    <div class="w-full flex flex-col items-center justify-center" style="height: 95vh" id="login">
      <template v-if="!setup">
        <div class="text-4xl mb-12">Вход</div>
        <div
          class="border border-dotted bg-gray-200 dark:bg-gray-800 shadow-lg rounded-xl p-4 flex flex-row items-center justify-center"
        >
          <InputText
            @keyup="onNameKeyUp"
            v-model="name"
            class="rounded-md p-2"
            placeholder="Имя пользователя"
          />
          <InputText
            @keyup="onKeyUp"
            v-model="secret"
            class="rounded-md p-2 mx-4"
            placeholder="Пароль"
            :type="mouseHold ? 'text' : 'password'"
          />
          <i
            :class="{
            pi: true,
            'pi-eye': !mouseHold,
            'pi-eye-slash': mouseHold,
            'mr-4': true,
            'text-gray-500': true,
            'text-2xl': true,
            'cursor-pointer': true
          }"
            @mousedown="mouseHold = true"
            @mouseup="mouseHold = false"
            @mouseout="mouseHold = false"
            @mouseleave="mouseHold = false"
          />
          <Button @click="formLogin">
            <i
              v-if="loading"
              class="pi pi-spinner animate-spin text-emerald-500"
              style="font-size: 2rem"
            />
            <i v-else class="pi pi-sign-in text-emerald-500" style="font-size: 2rem" />
          </Button>
        </div>
      </template>
      <template v-else>
        <div class="text-4xl mb-12 text-yellow-500">{{ userName }}, придумай новый пароль</div>
        <div
          class="border border-dotted bg-yellow-200 dark:bg-slate-800 shadow-lg rounded-xl p-4 flex flex-row items-center justify-center"
        >
          <InputText
            @keyup="onNameKeyUp"
            v-model="newPassword1"
            :class="{
            'rounded-md': true,
            'p-2': true,
            'bg-red-400 dark:bg-red-900': (!validPassword() && newPassword1.length) || error,
          }"
            placeholder="Новый пароль"
            type="password"
          />
          <InputText
            @keyup="onPasswordKeyUp"
            v-model="newPassword2"
            :class="{
            'rounded-md': true,
            'p-2': true,
            'mx-4': true,
            'bg-red-400 dark:bg-red-900':
              (newPassword1 !== newPassword2 && newPassword2.length) || error,
          }"
            placeholder="Повторите пароль"
            type="password"
          />
          <Button @click="formSendPassword">
            <i
              v-if="loading"
              class="pi pi-spinner animate-spin text-emerald-500"
              style="font-size: 2rem"
            />
            <i v-else class="pi pi-sign-in text-emerald-500" style="font-size: 2rem" />
          </Button>
        </div>
      </template>
      <div class="text-red-500 mt-2">{{ error || '&nbsp;' }}</div>
      <div class="text-xl mt-4 text-gray-500 text-center">
      <span v-if="setup">
        текст должен быть длиной не менее 8 символов и<br />
        содержать большие и маленькие буквы и цифры
      </span>
        <span v-else>
        &nbsp;<br />
        &nbsp;
      </span>
      </div>
    </div>
  </content>
</template>

<style scoped lang="scss"></style>

<style lang="scss">
#login {
  .p-panel-content {
    @apply flex flex-col justify-center text-center;
  }
}
</style>
